import React from "react";
import style from "./communityAcupuncture.module.scss";

import acupun_jpg from "./img/community_acupuncture.jpg";

function CommunityAcupuncture() {
    return (
        <div className={style.communityAcupuncture} id="community-acupuncture">
            <div className="container">
                <div className={style.communityAcupuncture__content}>
                <h2 className={style.communityAcupuncture__contentTitle}>COMMUNITY ACUPUNCTURE</h2>
                    <div className={style.communityAcupuncture__contentImage}>
                        <img src={acupun_jpg} alt="community acupuncture" width="1221px" height="733px"/>
                    </div>
                    <div className={style.communityAcupuncture__contentBody}>
                <p>Community acupuncture is the practice of treating patients together in a large room. This differs
                    from traditional acupuncture where treatment is administered in a private room setting.</p>

                <p>Our community acupuncture space features 4 zero gravity chairs and 2 massage beds, all set 4-6 feet
                    apart from each other.</p>

                <p>The model for community acupuncture mirrors how acupuncture was originally practiced
                    and also how it is still practiced in many Asian countries today.</p>

                <p>Many acupuncture clinics in the USA have adopted a community acupuncture model
                    to make treatment more accessible and affordable.</p>

                <p>Treating patients in a community setting has many benefits.</p>
                <ul>
                    <li>Friends and families may seek treatment together as many patients find it comforting
                        to be with a group instead of in a private session</li>
                    <li>Treatment in a group setting establishes a common healing space, an energetic
                        field that's been shown to make individual treatments more powerful.</li>
                </ul>

                <p>Each patient receives an individualized acupuncture treatment that addresses their specific needs.
                    The atmosphere is quiet and meditative, with many falling asleep once their needles are in.</p>

                <p>Community acupuncture also allows greater access by its affordability. AcuBoston-Dedham's fees will be priced as follows:<br/>
                <b>$25-$45 sliding scale, no proof of income required / hardship rate: $10.<br/>
                [If you like your first treatment and want to save even more, buy a package of 10 treatments for $220]</b></p>

                <p>Community acupuncture offers a beautiful way to seek rest and healing no matter
                    where you are in your acupuncture journey.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CommunityAcupuncture;